import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import servicesBoxStyles from './servicesBoxStyles.module.scss';
import { actions } from '../../../state';
import Boxes from './../boxes/boxes';
import { InputElement } from './../../../components';
import { formattedDevices } from '../locations.utils';

const getOptionPrice = (options, type) => {
  const option = options.find(obj => obj.type === type);
  return option ? option.price / 100 : '';
};

const SmartVacuumCleaner = ({ dispatch, data, requestError }) => {
  const [values, setValues] = useState({
    regular: data !== null ? getOptionPrice(data.options, 301) : '',
    mid: data !== null ? getOptionPrice(data.options, 302) : '',
    max: data !== null ? getOptionPrice(data.options, 303) : '',
  });

  const [devices, setBoxesValues] = useState(data === null ? [] : data.devices);
  const handleInputChange = ({ target: { name, value } }) => {
    setValues({ ...values, [name]: value });
  };

  useEffect(() => {
    const options = [
      {
        type: 301,
        price: values.regular * 100,
      },
      {
        type: 302,
        price: values.mid * 100,
      },
      {
        type: 303,
        price: values.max * 100,
      },
    ];
    const data = {
      options,
      devices: formattedDevices(devices),
    };
    dispatch(actions.addEditServices.pushSmartVacuumCleanerAction(data));
  });

  const handleStateFromBoxes = x => {
    setBoxesValues(x);
  };
  return (
    <div className={servicesBoxStyles.mainContainer}>
      <table className={servicesBoxStyles.container}>
        <thead>
          <tr>
            <th>Pavadinimas</th>
            <th>Kaina su PVM (EUR)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className={servicesBoxStyles.name}>3 min</td>
            <td className={servicesBoxStyles.pricePlanInput}>
              <InputElement
                name="regular"
                type="number"
                onChange={handleInputChange}
                value={values.regular}
                invalid={requestError && !values.regular}
                placeholder="0.00"
                min="0"
                step="0.01"
              />
            </td>
          </tr>
          <tr>
            <td className={servicesBoxStyles.name}>6 min</td>
            <td className={servicesBoxStyles.pricePlanInput}>
              <InputElement
                name="mid"
                type="number"
                onChange={handleInputChange}
                value={values.mid}
                invalid={requestError && !values.mid}
                placeholder="0.00"
                min="0"
                step="0.01"
              />
            </td>
          </tr>
          <tr>
            <td className={servicesBoxStyles.name}>9 min</td>
            <td className={servicesBoxStyles.pricePlanInput}>
              <InputElement
                name="max"
                type="number"
                onChange={handleInputChange}
                value={values.max}
                invalid={requestError && !values.max}
                placeholder="0.00"
                min="0"
                step="0.01"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <Boxes
        handleStateFromBoxes={handleStateFromBoxes}
        devices={data === null ? [] : data.devices}
        location="smart_vacuum_cleaner"
        requestError={requestError}
      />
    </div>
  );
};

SmartVacuumCleaner.propTypes = {
  dispatch: PropTypes.func,
  data: PropTypes.shape({
    devices: PropTypes.array.isRequired,
    id: PropTypes.number.isRequired,
    options: PropTypes.array.isRequired,
    status: PropTypes.number.isRequired,
    type: PropTypes.number.isRequired,
  }),
};

export default connect()(SmartVacuumCleaner);
